/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dosage-dilution.reducer';

export const DosageDilutionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dosageDilutionEntity = useAppSelector(state => state.dosageDilution.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dosageDilutionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dosageDilution.detail.title">DosageDilution</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.id">Id</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.id}</dd>
          <dt>
            <span id="diluentValue">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.diluentValue">Diluent Value</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.diluentValue}</dd>
          <dt>
            <span id="diluentUnit">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.diluentUnit">Diluent Unit</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.diluentUnit}</dd>
          <dt>
            <span id="recommendedSolute">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.recommendedSolute">Recommended Solute</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.recommendedSolute}</dd>
          <dt>
            <span id="soluteUnit">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.soluteUnit">Solute Unit</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.soluteUnit}</dd>
          <dt>
            <span id="solutetValue">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.solutetValue">Solutet Value</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.solutetValue}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.active">Active</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.dosageDilution.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{dosageDilutionEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dosageDilution.solute">Solute</Translate>
          </dt>
          <dd>{dosageDilutionEntity.solute ? dosageDilutionEntity.solute.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dosageDilution.diluent">Diluent</Translate>
          </dt>
          <dd>{dosageDilutionEntity.diluent ? dosageDilutionEntity.diluent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dosageDilution.regimenDrug">Regimen Drug</Translate>
          </dt>
          <dd>{dosageDilutionEntity.regimenDrug ? dosageDilutionEntity.regimenDrug.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/dosage-dilution" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dosage-dilution/${dosageDilutionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DosageDilutionDetail;
